/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::82f863baa2fdb06ade97da33950d1a23>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _UNSAFE_baseNew = _interopRequireDefault(require("@atlaskit/icon/UNSAFE_base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Database".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for databases in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const DatabaseIcon = props => /*#__PURE__*/_react.default.createElement(_UNSAFE_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 7.25V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v4.25m-12.5 0H8m-6.25 0v3.5m12.5-3.5H8m6.25 0v3.5M8 7.25v3.5m0 3.5h5c.69 0 1.25-.56 1.25-1.25v-2.25M8 14.25H3c-.69 0-1.25-.56-1.25-1.25v-2.25M8 14.25v-3.5m0 0h6.25m-6.25 0H1.75"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
DatabaseIcon.displayName = 'DatabaseIcon';
var _default = exports.default = DatabaseIcon;